module.exports = __webpack_public_path__ + "static/media/btmtpc.3d0eb0ca.png";